import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import jssVariables from "../../../jss_setup";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";

const descriptionStyles = createUseStyles({
  description: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    color: jssVariables.colors.text.dark,
    width: "90vw",
    alignContent: "baseline",
    ..._.get(props, "customStyles.description", {}),
  }),
  descTxt: (props) => ({
    display: "grid",
    fontSize: "larger",
    maxHeight: "100%",
    overflow: "hidden",
    transition: ".5s",
    ..._.get(props, "customStyles.descTxt", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    description: (props) => ({
      width: "100%",
      ..._.get(props, "customStyles.description.smallscreen", {}),
    }),
    descTxt: (props) => ({
      gridTemplateRows: "max-content",
      ..._.get(props, "customStyles.descTxt.smallscreen", {}),
    }),
  },
});
const Description = ({ details }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const classes = descriptionStyles({
    type,
    customStyles: cStyler({
      type,
      brand,
      objName: "tourViewStyles",
    }),
  });

  const {
    i18n: { language },
  } = useContext(TranslationContext);

  const langKey = _.lowerCase(language.split("-")[0]);

  var subTitle = _.get(details, "subtitle", "");
  var description = _.get(
    details,
    `general_description.description_${langKey}`,
    ""
  );

  return (
    <div className={classes.description}>
      {subTitle && type !== "type2" ? (
        <h3 className={classes.title}>{subTitle}</h3>
      ) : null}
      <div className={classes.descTxt}>
        <span dangerouslySetInnerHTML={{ __html: description }}></span>
      </div>
    </div>
  );
};
Description.defaultProps = {
  details: {},
};
Description.propTypes = {
  details: PropTypes.object.isRequired,
};
export default Description;
